var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"item",staticClass:"zm-dropdown-menu__item",class:{
    'is-disabled': _vm.disabled,
    'zm-dropdown-menu__item--divided': _vm.divided,
    'is-hover':_vm.hover
  },attrs:{"aria-disabled":_vm.disabled,"id":_vm.itemId,"role":"menuitem","aria-label":_vm.ariaLabel},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }